module.exports = __webpack_public_path__ + "media/images/checkBadge-a338d06766ae0d98e7bdae156fc2b8b3.svg";